import {
  nationalIdType,
  emailType,
  phonenumberType,
  usernameType,
  passwordType,
  firstNameType,
  lastNameType,
  addressType,
  zipType,
  cityType
} from './identifyFieldsTypes'

export const nationalId: nationalIdType = {
  id: 'nationalId',
  name: 'nationalId',
  autocomplete: 'off',
  icon: 'person-outline',
  type: 'tel',
  pattern: '[0-9]*',
  size: '100',
  required: true,
  autoValidate: true,
  editable: true
}

export const email: emailType = {
  id: 'email',
  name: 'email',
  icon: 'mail-outline',
  maxLength: '40',
  type: 'email',
  size: '100',
  required: true,
  autoValidate: false,
  editable: true,
  validateMessage: 'must_be_a_valid_email_address',
  validateMethod: (email): boolean => {
    const emailRegExp = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i
    return emailRegExp.test(email)
  }
}

export const phonenumber: phonenumberType = {
  id: 'phonenumber',
  name: 'phonenumber',
  icon: 'call-outline',
  type: 'tel',
  pattern: '[0-9]*',
  maxLength: '12',
  size: '100',
  required: true,
  autoValidate: true,
  editable: true,
  validateMessage: 'phonenumber_must_be_10_digits',
  validateMethod: (phonenumber): boolean => {
    return phonenumber.length >= 10
  }
}

export const username: usernameType = {
  id: 'username',
  name: 'username',
  icon: 'person-outline',
  type: 'text',
  maxLength: '50',
  size: '100',
  required: true,
  includeInKYC: false,
  autoValidate: false,
  editable: true,
  validateMessage: 'phonenumber_must_be_longer_than_two',
  validateMethod: (username): boolean => {
    return username.length >= 2
  }
}

export const password: passwordType = {
  id: 'password',
  name: 'password',
  icon: 'lock-closed-outline',
  type: 'password',
  maxLength: '50',
  size: '100',
  required: true,
  includeInKYC: false,
  autoValidate: false,
  editable: true,
  validateMessage: 'password_must_be_longer_than_two',
  validateMethod: (password): boolean => {
    return password.length >= 2
  }
}

export const firstName: firstNameType = {
  id: 'firstName',
  name: 'fname',
  autocomplete: 'given-name',
  type: 'text',
  maxLength: '30',
  size: '50',
  required: true,
  editable: false,
  validateMethod: (firstName: string): boolean => {
    return firstName.length > 1
  }
}

export const lastName: lastNameType = {
  id: 'lastName',
  name: 'lname',
  autocomplete: 'family-name',
  type: 'text',
  maxLength: '30',
  size: '50',
  required: true,
  editable: false,
  validateMethod: (lastName: string): boolean => {
    return lastName.length > 1
  }
}

export const address1: addressType = {
  id: 'address1',
  type: 'text',
  size: '100',
  required: true,
  editable: true,
  validateMethod: (address1): boolean => {
    return address1 !== ''
  }
}

export const address2: addressType = {
  id: 'address2',
  type: 'text',
  size: '100',
  tabIndex: '-1',
  editable: true,
  required: false
}

export const zip: zipType = {
  id: 'zip',
  icon: 'location-outline',
  type: 'tel',
  pattern: '[0-9]*',
  maxLength: '6',
  size: '50',
  required: true,
  autoValidate: true,
  editable: true,
  validateMethod: (zip): boolean => {
    return zip.length >= 5
  }
}

export const city: cityType = {
  id: 'city',
  type: 'text',
  maxLength: '30',
  size: '50',
  required: true,
  editable: true,
  validateMethod: (city): boolean => {
    return city.length >= 3
  }
}

/* Country specific fields/extended fields */

/* Sweden */
export const nationalIdSweden: object = {
  maxLength: '12',
  editable: false,
  validateMessage: 'must_be_a_valid_nationalid',
  validateMethod: (nationalId): boolean => {
    const re = /^(19|20)?(\d{6}([-+]|\s)\d{4}|(?!19|20)\d{10})$/
    return re.test(nationalId)
  }
}

/* Norway */

export const phonenumberNorway: object = {
  validateMessage: 'phonenumber_must_be_8_or_12_digits',
  validateMethod: (phonenumber): boolean => {
    return phonenumber.length >= 8 && phonenumber.length <= 12
  }
}

export const zipNorway: object = {
  validateMessage: 'zip_must_be_4_digits',
  validateMethod: (zip): boolean => {
    return zip.length === 4
  }
}
